export default __webpack_public_path__ + "static/media/img1.0b67c123.jpg";